/**
 * Baseclass for BRM Errors
 */
export class BrmError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}
